/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 *
 *
 * 1 = DateReceived
 *
 * 2 = HighDensityMail
 *
 * 3 = MailBox
 *
 * 4 = Location
 *
 * 5 = Carrier
 *
 * 6 = Lockers
 * @format int32
 */
export enum Workflow {
  DateReceived = 1,
  HighDensityMail = 2,
  MailBox = 3,
  Location = 4,
  Carrier = 5,
  Lockers = 6,
}

/**
 *
 *
 * 0 = Valid
 *
 * 1 = BadFormat
 *
 * 2 = Conflict
 * @format int32
 */
export enum TrackingNumberValidationStatus {
  Valid = 0,
  BadFormat = 1,
  Conflict = 2,
}

/**
 *
 *
 * 0 = None
 *
 * 1 = Sent
 *
 * 2 = Confirmed
 *
 * 3 = Failed
 *
 * 4 = Canceled
 * @format int32
 */
export enum TrackingNumberAnnouncementStatus {
  None = 0,
  Sent = 1,
  Confirmed = 2,
  Failed = 3,
  Canceled = 4,
}

/**
 *
 *
 * 0 = ShippingLabel
 *
 * 1 = EmailNotification
 * @format int32
 */
export enum TemplateType {
  ShippingLabel = 0,
  EmailNotification = 1,
}

/**
 *
 *
 * 0 = Trial
 *
 * 1 = TrialExpired
 *
 * 2 = Live
 *
 * 3 = Dunning
 *
 * 4 = Unpaid
 *
 * 5 = Future
 *
 * 6 = NonRenewing
 *
 * 7 = Canceled
 *
 * 8 = Expired
 * @format int32
 */
export enum SubscriptionStatus {
  Trial = 0,
  TrialExpired = 1,
  Live = 2,
  Dunning = 3,
  Unpaid = 4,
  Future = 5,
  NonRenewing = 6,
  Canceled = 7,
  Expired = 8,
}

/**
 *
 *
 * 0 = Deleted
 *
 * 1 = Active
 *
 * 2 = Draft
 * @format int32
 */
export enum Status {
  Deleted = 0,
  Active = 1,
  Draft = 2,
}

/**
 *
 *
 * 1 = String
 *
 * 2 = Boolean
 *
 * 3 = Number
 *
 * 4 = Array
 *
 * 5 = Json
 * @format int32
 */
export enum SettingType {
  String = 1,
  Boolean = 2,
  Number = 3,
  Array = 4,
  Json = 5,
}

/**
 *
 *
 * 1 = General
 *
 * 2 = Notifications
 *
 * 3 = Mailroom
 *
 * 4 = UserRegistration
 *
 * 5 = AvailableActions
 *
 * 6 = AvailableNotifications
 *
 * 7 = ReceiveDefaults
 *
 * 8 = PieceAutomatedActions
 *
 * -2 = Private
 *
 * -1 = Internal
 * @format int32
 */
export enum SettingGroup {
  General = 1,
  Notifications = 2,
  Mailroom = 3,
  UserRegistration = 4,
  AvailableActions = 5,
  AvailableNotifications = 6,
  ReceiveDefaults = 7,
  PieceAutomatedActions = 8,
  Private = -2,
  Internal = -1,
}

/**
 *
 *
 * 0 = Identified
 *
 * 1 = IdentifiedBasedOnPreviousAssignment
 *
 * 2 = IdentifiedVerificationRequired
 *
 * 3 = IdentifiedMultipleMatches
 *
 * 4 = IdentifiedAndNotExist
 *
 * 5 = Failed
 * @format int32
 */
export enum RecipientAutoDetectionStatus {
  Identified = 0,
  IdentifiedBasedOnPreviousAssignment = 1,
  IdentifiedVerificationRequired = 2,
  IdentifiedMultipleMatches = 3,
  IdentifiedAndNotExist = 4,
  Failed = 5,
}

/**
 *
 *
 * 0 = All
 *
 * 1 = InProgress
 *
 * 2 = Closed
 * @format int32
 */
export enum ReceiveSessionFilterStatus {
  All = 0,
  InProgress = 1,
  Closed = 2,
}

/**
 *
 *
 * 1 = Mail
 *
 * 2 = Package
 * @format int32
 */
export enum PieceType {
  Mail = 1,
  Package = 2,
}

/**
 *
 *
 * 0 = All
 *
 * 1 = Stored
 *
 * 2 = Unstored
 * @format int32
 */
export enum PieceStoredStatusFilter {
  All = 0,
  Stored = 1,
  Unstored = 2,
}

/**
 *
 *
 * 0 = Sent
 *
 * 1 = Unsent
 * @format int32
 */
export enum PieceStatus {
  Sent = 0,
  Unsent = 1,
}

/**
 *
 *
 * 0 = NA
 *
 * 10 = Created
 *
 * 20 = Assigned
 *
 * 30 = Submitted
 *
 * 40 = ActionRequested
 *
 * 50 = ActionTaken
 *
 * 60 = Archived
 *
 * -1 = Deleted
 * @format int32
 */
export enum PieceState {
  NA = 0,
  Created = 10,
  Assigned = 20,
  Submitted = 30,
  ActionRequested = 40,
  ActionTaken = 50,
  Archived = 60,
  Deleted = -1,
}

/**
 *
 *
 * PieceAssets
 *
 * Company
 *
 * User
 *
 * Recipient
 *
 * LifecycleStage
 *
 * Users
 *
 * Workflow
 *
 * Events
 *
 * PieceDoc
 *
 * RecipientAutoDetection
 *
 * PieceLocation
 *
 * Available
 *
 * Scanned
 *
 * CommentsCount
 *
 * ActionRequiredBy
 *
 * TrackingNumbers
 *
 * SenderName
 *
 * PurchaseOrderNumber
 *
 * PurchaseInvoiceNumber
 *
 * Reference1Number
 *
 * Reference2Number
 *
 * Reference3Number
 *
 * ShippingCarriers
 *
 * CompletedActions
 *
 * RecipientLocation
 *
 * RecipientRoutes
 *
 * ArchivedDate
 *
 * MailClassName
 *
 * SentStatus
 *
 * None
 */
export enum PieceIncludeOption {
  PieceAssets = "PieceAssets",
  Company = "Company",
  User = "User",
  Recipient = "Recipient",
  LifecycleStage = "LifecycleStage",
  Users = "Users",
  Workflow = "Workflow",
  Events = "Events",
  PieceDoc = "PieceDoc",
  RecipientAutoDetection = "RecipientAutoDetection",
  PieceLocation = "PieceLocation",
  Available = "Available",
  Scanned = "Scanned",
  CommentsCount = "CommentsCount",
  ActionRequiredBy = "ActionRequiredBy",
  TrackingNumbers = "TrackingNumbers",
  SenderName = "SenderName",
  PurchaseOrderNumber = "PurchaseOrderNumber",
  PurchaseInvoiceNumber = "PurchaseInvoiceNumber",
  Reference1Number = "Reference1Number",
  Reference2Number = "Reference2Number",
  Reference3Number = "Reference3Number",
  ShippingCarriers = "ShippingCarriers",
  CompletedActions = "CompletedActions",
  RecipientLocation = "RecipientLocation",
  RecipientRoutes = "RecipientRoutes",
  ArchivedDate = "ArchivedDate",
  MailClassName = "MailClassName",
  SentStatus = "SentStatus",
  None = "None",
}

/**
 *
 *
 * 0 = Mailroom
 *
 * 1 = Inbox
 * @format int32
 */
export enum PieceFilterScope {
  Mailroom = 0,
  Inbox = 1,
}

/**
 *
 *
 * 0 = All
 *
 * 1 = Assigned
 *
 * 2 = Unassigned
 * @format int32
 */
export enum PieceAssignmentStatusFilter {
  All = 0,
  Assigned = 1,
  Unassigned = 2,
}

/**
 *
 *
 * 1 = Original
 *
 * 2 = AutoCropped
 *
 * 3 = Cropped
 *
 * 5 = PickupSignature
 *
 * 6 = MlImage
 *
 * 7 = PdfDocument
 *
 * 8 = DeliveryImage
 *
 * 9 = PickupImage
 * @format int32
 */
export enum PieceAssetType {
  Original = 1,
  AutoCropped = 2,
  Cropped = 3,
  PickupSignature = 5,
  MlImage = 6,
  PdfDocument = 7,
  DeliveryImage = 8,
  PickupImage = 9,
}

/**
 *
 *
 * 1 = Large
 *
 * 2 = Medium
 *
 * 3 = Small
 * @format int32
 */
export enum PieceAssetSize {
  Large = 1,
  Medium = 2,
  Small = 3,
}

/**
 *
 *
 * 0 = ChainOfCustody
 *
 * 1 = System
 * @format int32
 */
export enum PieceActionType {
  ChainOfCustody = 0,
  System = 1,
}

/**
 *
 *
 * 0 = NA
 *
 * 1 = EmailNotification
 *
 * 2 = SmsNotification
 *
 * 101 = Create
 *
 * 102 = Assign
 *
 * 103 = Store
 *
 * 104 = CropImage
 *
 * 201 = Submit
 *
 * 202 = RequestForward
 *
 * 203 = Move
 *
 * 301 = RequestRecycle
 *
 * 302 = RequestOpenAndScan
 *
 * 303 = RequestMail
 *
 * 304 = RequestPickUp
 *
 * 305 = RequestShred
 *
 * 306 = RequestDelivery
 *
 * 307 = RequestLockerPickUp
 *
 * 308 = RequestReturnToSender
 *
 * 401 = FinishRecycle
 *
 * 402 = FinishOpenAndScan
 *
 * 403 = FinishMail
 *
 * 404 = FinishPickUp
 *
 * 405 = FinishShred
 *
 * 406 = FinishPickUpWithSignature
 *
 * 407 = FinishPickUpWithQrCode
 *
 * 408 = FinishDelivery
 *
 * 409 = FinishDeliveryWithSignature
 *
 * 410 = FinishDeliveryWithQrCode
 *
 * 411 = FinishPickUpWithPinCode
 *
 * 412 = FinishPickUpUnload
 *
 * 413 = FinishDeliveryWithImage
 *
 * 414 = FinishPickupWithImage
 *
 * 415 = FinishReturnToSender
 *
 * 416 = FinishPickupWithIdCard
 *
 * 417 = FinishPickupMailbox
 *
 * 501 = RemindAction
 *
 * 502 = EscalateAction
 *
 * 503 = RemindReview
 *
 * 504 = EscalateReview
 *
 * 505 = RemindLockerPickup
 *
 * 506 = LockerExp
 *
 * 601 = ViewDoc
 *
 * 602 = DownloadDoc
 *
 * 603 = ScheduleDocumentNotViewedEscalation
 *
 * 604 = SchedulePieceNoActivityEscalation
 *
 * 605 = ScheduleDocumentNotViewed
 *
 * 606 = SchedulePieceNoActivity
 *
 * 607 = ScheduleLockersPickupReminder
 *
 * 608 = AutoCroppingComplete
 *
 * 609 = BarcodeDetectionComplete
 *
 * 610 = AutoCroppingSkipped
 *
 * 611 = AutoAssign
 *
 * 901 = Archive
 *
 * -1 = Delete
 * @format int32
 */
export enum PieceAction {
  NA = 0,
  EmailNotification = 1,
  SmsNotification = 2,
  Create = 101,
  Assign = 102,
  Store = 103,
  CropImage = 104,
  Submit = 201,
  RequestForward = 202,
  Move = 203,
  RequestRecycle = 301,
  RequestOpenAndScan = 302,
  RequestMail = 303,
  RequestPickUp = 304,
  RequestShred = 305,
  RequestDelivery = 306,
  RequestLockerPickUp = 307,
  RequestReturnToSender = 308,
  FinishRecycle = 401,
  FinishOpenAndScan = 402,
  FinishMail = 403,
  FinishPickUp = 404,
  FinishShred = 405,
  FinishPickUpWithSignature = 406,
  FinishPickUpWithQrCode = 407,
  FinishDelivery = 408,
  FinishDeliveryWithSignature = 409,
  FinishDeliveryWithQrCode = 410,
  FinishPickUpWithPinCode = 411,
  FinishPickUpUnload = 412,
  FinishDeliveryWithImage = 413,
  FinishPickupWithImage = 414,
  FinishReturnToSender = 415,
  FinishPickupWithIdCard = 416,
  FinishPickupMailbox = 417,
  RemindAction = 501,
  EscalateAction = 502,
  RemindReview = 503,
  EscalateReview = 504,
  RemindLockerPickup = 505,
  LockerExp = 506,
  ViewDoc = 601,
  DownloadDoc = 602,
  ScheduleDocumentNotViewedEscalation = 603,
  SchedulePieceNoActivityEscalation = 604,
  ScheduleDocumentNotViewed = 605,
  SchedulePieceNoActivity = 606,
  ScheduleLockersPickupReminder = 607,
  AutoCroppingComplete = 608,
  BarcodeDetectionComplete = 609,
  AutoCroppingSkipped = 610,
  AutoAssign = 611,
  Archive = 901,
  Delete = -1,
}

/**
 *
 *
 * 0 = Week
 *
 * 1 = Month
 *
 * 2 = Year
 *
 * 3 = Today
 *
 * 4 = NotToday
 * @format int32
 */
export enum PeriodType {
  Week = 0,
  Month = 1,
  Year = 2,
  Today = 3,
  NotToday = 4,
}

/**
 *
 *
 * 0 = Months
 *
 * 1 = Years
 * @format int32
 */
export enum PaymentInterval {
  Months = 0,
  Years = 1,
}

/**
 *
 *
 * 0 = Add
 *
 * 1 = Remove
 * @format int32
 */
export enum LocationUserOperationType {
  Add = 0,
  Remove = 1,
}

/**
 *
 *
 * 0 = Unchanged
 *
 * 1 = Added
 *
 * 2 = Activated
 *
 * 3 = Updated
 *
 * 4 = Inactivated
 *
 * 5 = Error
 * @format int32
 */
export enum ImportState {
  Unchanged = 0,
  Added = 1,
  Activated = 2,
  Updated = 3,
  Inactivated = 4,
  Error = 5,
}

/**
 *
 *
 * 0 = Sunday
 *
 * 1 = Monday
 *
 * 2 = Tuesday
 *
 * 3 = Wednesday
 *
 * 4 = Thursday
 *
 * 5 = Friday
 *
 * 6 = Saturday
 * @format int32
 */
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

/**
 *
 *
 * 0 = None
 *
 * 1 = AddToBack
 *
 * 2 = AddToFront
 * @format int32
 */
export enum ContainerSortOrder {
  None = 0,
  AddToBack = 1,
  AddToFront = 2,
}

/**
 *
 *
 * 0 = All
 *
 * 1 = WithUnsentItems
 *
 * 2 = WithoutUnsentItems
 * @format int32
 */
export enum ContainerFilterStorageGroups {
  All = 0,
  WithUnsentItems = 1,
  WithoutUnsentItems = 2,
}

/**
 *
 *
 * 1 = Single
 *
 * 2 = Automated
 *
 * 3 = Images
 * @format int32
 */
export enum CaptureMethod {
  Single = 1,
  Automated = 2,
  Images = 3,
}

/**
 *
 *
 * 0 = Corporate
 *
 * 1 = University
 * @format int32
 */
export enum BusinessDomain {
  Corporate = 0,
  University = 1,
}

/**
 *
 *
 * 0 = Code39
 *
 * 1 = Code128
 *
 * 2 = Codabar
 *
 * 3 = UCC128
 *
 * 4 = Code93
 *
 * 5 = UPCA
 *
 * 6 = EAN8
 *
 * 7 = UPCE
 *
 * 8 = EAN13
 *
 * 9 = I25
 *
 * 10 = DataMatrix
 *
 * 11 = PDF417
 *
 * 12 = QR
 *
 * 13 = DrvLic
 *
 * 14 = IMB
 *
 * 15 = BPO
 *
 * 16 = Aust
 *
 * 17 = Sing
 *
 * 18 = FourState
 *
 * 19 = Patch
 * @format int32
 */
export enum BarcodeType {
  Code39 = 0,
  Code128 = 1,
  Codabar = 2,
  UCC128 = 3,
  Code93 = 4,
  UPCA = 5,
  EAN8 = 6,
  UPCE = 7,
  EAN13 = 8,
  I25 = 9,
  DataMatrix = 10,
  PDF417 = 11,
  QR = 12,
  DrvLic = 13,
  IMB = 14,
  BPO = 15,
  Aust = 16,
  Sing = 17,
  FourState = 18,
  Patch = 19,
}

/**
 *
 *
 * 0 = AllRecipients
 *
 * 1 = SpecificRecipients
 * @format int32
 */
export enum AutomationSetType {
  AllRecipients = 0,
  SpecificRecipients = 1,
}

/**
 *
 *
 * 0 = Recipient
 *
 * 1 = Sender
 *
 * 2 = TrackingNumber
 *
 * 3 = Carrier
 *
 * 4 = Reference1Number
 *
 * 5 = Reference2Number
 *
 * 6 = Reference3Number
 *
 * 7 = PurchaseOrderNumber
 *
 * 8 = PurchaseInvoiceNumber
 *
 * 9 = MailClass
 * @format int32
 */
export enum AnnotationType {
  Recipient = 0,
  Sender = 1,
  TrackingNumber = 2,
  Carrier = 3,
  Reference1Number = 4,
  Reference2Number = 5,
  Reference3Number = 6,
  PurchaseOrderNumber = 7,
  PurchaseInvoiceNumber = 8,
  MailClass = 9,
}

/**
 *
 *
 * 0 = Business
 *
 * 1 = Billing
 *
 * 2 = Contact
 *
 * 3 = Shipping
 *
 * 4 = Recipient
 *
 * 5 = Mailing
 * @format int32
 */
export enum AddressType {
  Business = 0,
  Billing = 1,
  Contact = 2,
  Shipping = 3,
  Recipient = 4,
  Mailing = 5,
}

export interface ActiveSpan {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 0 = Sunday
   *
   * 1 = Monday
   *
   * 2 = Tuesday
   *
   * 3 = Wednesday
   *
   * 4 = Thursday
   *
   * 5 = Friday
   *
   * 6 = Saturday
   */
  dayOfWeek: DayOfWeek;
  /** @format int32 */
  open: number;
  /** @format int32 */
  close: number;
}

export interface Address {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 0 = Business
   *
   * 1 = Billing
   *
   * 2 = Contact
   *
   * 3 = Shipping
   *
   * 4 = Recipient
   *
   * 5 = Mailing
   */
  addressType: AddressType;
  default: boolean;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  countryCode: string;
  /** @minLength 1 */
  administrativeArea: string;
  /** @minLength 1 */
  locality: string;
  /** @minLength 1 */
  postalCode: string;
  /** @minLength 1 */
  addressLine1: string;
  /** @minLength 1 */
  addressLine2: string;
}

export interface AddressArrayResponse {
  userMessage?: string | null;
  objectData: Address[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface AddressRequest {
  /** @format int32 */
  id?: number;
  /**
   *
   *
   * 0 = Business
   *
   * 1 = Billing
   *
   * 2 = Contact
   *
   * 3 = Shipping
   *
   * 4 = Recipient
   *
   * 5 = Mailing
   */
  addressType?: AddressType;
  default?: boolean;
  description?: string | null;
  countryCode?: string | null;
  administrativeArea?: string | null;
  locality?: string | null;
  postalCode?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
}

export interface AddressResponse {
  userMessage?: string | null;
  objectData: Address;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface AssignTemplateRequest {
  /** @format int32 */
  templateId?: number;
  printerName?: string | null;
}

export interface AssistantRequest {
  id?: string | null;
}

export interface BooleanResponse {
  userMessage?: string | null;
  objectData: boolean;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface BoundingBox {
  /** @format int32 */
  id: number;
  /** @format int32 */
  topLeftX: number;
  /** @format int32 */
  topLeftY: number;
  /** @format int32 */
  topRightX: number;
  /** @format int32 */
  topRightY: number;
  /** @format int32 */
  bottomLeftX: number;
  /** @format int32 */
  bottomLeftY: number;
  /** @format int32 */
  bottomRightX: number;
  /** @format int32 */
  bottomRightY: number;
}

export interface CameraInfo {
  success?: boolean;
  message?: string | null;
  /** @format int32 */
  index?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  /** @format double */
  fps?: number;
  name?: string | null;
  snapshotBase64?: string | null;
}

export interface CameraInfoResponse {
  userMessage?: string | null;
  objectData: CameraInfo;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CameraList {
  cameras?: CameraInfo[] | null;
}

export interface CameraListResponse {
  userMessage?: string | null;
  objectData: CameraList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CameraStart {
  success?: boolean;
  message?: string | null;
}

export interface CameraStartResponse {
  userMessage?: string | null;
  objectData: CameraStart;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CameraStop {
  success?: boolean;
  message?: string | null;
}

export interface CameraStopResponse {
  userMessage?: string | null;
  objectData: CameraStop;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Card {
  /** @minLength 1 */
  paymentMethodId: string;
  /** @minLength 1 */
  last4: string;
  /** @minLength 1 */
  brand: string;
  isDefault: boolean;
}

export interface CardArrayResponse {
  userMessage?: string | null;
  objectData: Card[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Company {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  email: string;
  phone?: string | null;
  /** @minLength 1 */
  subdomain: string;
  addresses: Address[];
  logoUrl?: string | null;
}

export interface CompanyArrayResponse {
  userMessage?: string | null;
  objectData: Company[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CompanyPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: Company[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface CompanyPagedListResponse {
  userMessage?: string | null;
  objectData: CompanyPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CompanyResponse {
  userMessage?: string | null;
  objectData: Company;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Container {
  /** @format int32 */
  id: number;
  containerType: ContainerType;
  containerNumber?: string | null;
  /** @format date-time */
  createdDate: string;
  /** @format date-time */
  updatedDate: string;
  lastPieceAssets: PieceAsset[];
  /** @format int32 */
  allCount: number;
  /** @format int32 */
  sentCount: number;
  /** @format int32 */
  unsentCount: number;
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  sortOrder: string;
  /** @format int64 */
  nextOrderNo: number;
  /** @minLength 1 */
  containerTitleFormatted: string;
  /** @minLength 1 */
  containerCardTitleFormatted: string;
  /** @minLength 1 */
  containerDateFormatted: string;
}

export interface ContainerPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: Container[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface ContainerPagedListResponse {
  userMessage?: string | null;
  objectData: ContainerPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ContainerRequest {
  /** @format int32 */
  id?: number | null;
  /** @format date-time */
  createdDate?: string | null;
  /** @format int32 */
  containerTypeId: number;
  containerNumber?: string | null;
  sortOrder?: string | null;
  userId?: string | null;
}

export interface ContainerResponse {
  userMessage?: string | null;
  objectData: Container;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ContainerType {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  workflow: string;
  /** @minLength 1 */
  containerUiLabel: string;
}

export interface ContainerTypeArrayResponse {
  userMessage?: string | null;
  objectData: ContainerType[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CreateActiveSpanRequest {
  /**
   *
   *
   * 0 = Sunday
   *
   * 1 = Monday
   *
   * 2 = Tuesday
   *
   * 3 = Wednesday
   *
   * 4 = Thursday
   *
   * 5 = Friday
   *
   * 6 = Saturday
   */
  dayOfWeek: DayOfWeek;
  /** @format int32 */
  open: number;
  /** @format int32 */
  close: number;
}

export interface CreateBatchPieceAnnotationsRequest {
  annotations?: CreatePieceAnnotationRequest[] | null;
}

export interface CreateBoundingBoxRequest {
  /** @format int32 */
  topLeftX?: number;
  /** @format int32 */
  topLeftY?: number;
  /** @format int32 */
  topRightX?: number;
  /** @format int32 */
  topRightY?: number;
  /** @format int32 */
  bottomLeftX?: number;
  /** @format int32 */
  bottomLeftY?: number;
  /** @format int32 */
  bottomRightX?: number;
  /** @format int32 */
  bottomRightY?: number;
}

export interface CreateCompanyRequest {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  subdomain: string;
}

export interface CreateDeliveryRouteRequest {
  /** @minLength 1 */
  name: string;
  locations?: LocationRequest[] | null;
}

export interface CreateHoursOfOperationRequest {
  /** @minLength 1 */
  timeZoneInfoId: string;
  activeSpans?: CreateActiveSpanRequest[] | null;
}

export interface CreateLocationRequest {
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  sortOrder?: number;
  userIds?: string[] | null;
}

export interface CreateMailroomRequest {
  /** @minLength 1 */
  name: string;
  address?: AddressRequest;
  email?: string | null;
  /** @format date-time */
  openTime?: string | null;
  /** @format date-time */
  closeTime?: string | null;
  hoursOfOperation?: CreateHoursOfOperationRequest;
}

export interface CreatePieceAnnotationRequest {
  /** @format int32 */
  pieceId?: number;
  /**
   *
   *
   * 0 = Recipient
   *
   * 1 = Sender
   *
   * 2 = TrackingNumber
   *
   * 3 = Carrier
   *
   * 4 = Reference1Number
   *
   * 5 = Reference2Number
   *
   * 6 = Reference3Number
   *
   * 7 = PurchaseOrderNumber
   *
   * 8 = PurchaseInvoiceNumber
   *
   * 9 = MailClass
   */
  annotationType?: AnnotationType;
  textValue?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
  boundingBox?: CreateBoundingBoxRequest;
}

export interface CreatePieceCommentRequest {
  /** @format int32 */
  parentCommentId?: number | null;
  text?: string | null;
  /** @format int32 */
  pieceId?: number;
  notifyMailroom?: boolean;
}

export interface CreatePieceCommentsRequest {
  /** @minLength 1 */
  text: string;
  notifyMailroom?: boolean;
  pieceIds: number[];
}

export interface CreatePieceDocRequest {
  /** @format int32 */
  pieceId?: number;
}

export interface CreatePieceFormRequest {
  /** @minLength 1 */
  originalFileBase64: string;
  /** @format int64 */
  orderNo?: number | null;
  /** @format uuid */
  receiveSessionId: string;
  /** @format int32 */
  imageWidth: number;
  /** @format int32 */
  imageHeight: number;
}

export interface CreatePiecePageRequest {
  /** @format int32 */
  pieceDocId: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  originalKey: string;
  /** @maxLength 255 */
  croppedKey?: string | null;
  /** @maxLength 255 */
  thumbnailKey?: string | null;
  /** @format int32 */
  sortOrder?: number;
}

export interface CreatePieceRequest {
  /** @maxLength 255 */
  originalLargeKey?: string | null;
  /** @maxLength 255 */
  originalMediumKey?: string | null;
  /** @maxLength 255 */
  originalSmallKey?: string | null;
  /** @format int64 */
  orderNo?: number | null;
  /** @format uuid */
  receiveSessionId: string;
  isDraft?: boolean;
}

export interface CreateUserRequest {
  userName?: string | null;
  autoAssignId?: string | null;
  /** @minLength 1 */
  email: string;
  phoneNumber?: string | null;
  supervisorId?: string | null;
  addresses?: AddressRequest[] | null;
  roles: string[];
  profileImageUrl?: string | null;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  quotaExceeded?: boolean;
  assistants?: AssistantRequest[] | null;
  /** @format int32 */
  locationId?: number | null;
  sendPasswordEmail?: boolean | null;
}

export interface Dashboard {
  /** @minLength 1 */
  timeZone: string;
  /** @format float */
  trend: number;
  data: DashboardItem[];
}

export interface DashboardItem {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  /** @format int32 */
  mail: number;
  /** @format int32 */
  package: number;
}

export interface DashboardResponse {
  userMessage?: string | null;
  objectData: Dashboard;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface DeliveryRoute {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  locations?: Location[] | null;
  createdBy: UserMin;
  /** @format date-time */
  createdOn: string;
  updatedBy: UserMin;
  /** @format date-time */
  updatedOn: string;
}

export interface DeliveryRoutePagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: DeliveryRoute[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface DeliveryRoutePagedListResponse {
  userMessage?: string | null;
  objectData: DeliveryRoutePagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface DeliveryRouteResponse {
  userMessage?: string | null;
  objectData: DeliveryRoute;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export type EmptyResult = object;

export interface EmptyResultResponse {
  userMessage?: string | null;
  objectData: EmptyResult;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Error {
  message?: string | null;
  code?: string | null;
  errorType?: string | null;
}

export interface HoursOfOperation {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  timeZoneInfoId: string;
  activeSpans: ActiveSpan[];
}

export interface ImportUserRequest {
  firstName?: string | null;
  lastName?: string | null;
  userName?: string | null;
  autoAssignId?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  supervisorEmail?: string | null;
  assistantsEmail?: string[] | null;
  location?: string | null;
  /** @format int32 */
  idx?: number;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  status?: Status;
}

export interface ImportUsersRequest {
  inactivateAllExceptImported?: boolean;
  cleanUserNameForAllExceptImported?: boolean;
  propsListForUpdate?: string[] | null;
  usersRequest?: ImportUserRequest[] | null;
  sendPasswordEmail?: boolean | null;
}

export interface Int32ArrayResponse {
  userMessage?: string | null;
  objectData: number[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Invoice {
  /** @format int32 */
  id: number;
  /** @format int32 */
  companyId: number;
  /** @minLength 1 */
  invoiceUrl: string;
  /** @format date-time */
  created: string;
  /** @format double */
  amount: number;
  /** @minLength 1 */
  currency: string;
  success: boolean;
}

export interface InvoiceArrayResponse {
  userMessage?: string | null;
  objectData: Invoice[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface InvoiceResponse {
  userMessage?: string | null;
  objectData: Invoice;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Location {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  sortOrder: number;
  children?: Location[] | null;
  createdBy: UserMin;
  /** @format date-time */
  createdOn: string;
  updatedBy: UserMin;
  /** @format date-time */
  updatedOn: string;
  userLocations?: UserLocation[] | null;
}

export interface LocationArrayResponse {
  userMessage?: string | null;
  objectData: Location[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface LocationPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: Location[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface LocationPagedListResponse {
  userMessage?: string | null;
  objectData: LocationPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface LocationRequest {
  /** @format int32 */
  id: number;
  /** @format int32 */
  sortOrder?: number;
}

export interface LocationResponse {
  userMessage?: string | null;
  objectData: Location;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Mailroom {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  address: Address;
  /** @minLength 1 */
  email: string;
  /** @format date-time */
  openTime: string;
  /** @format date-time */
  closeTime: string;
  hoursOfOperation: HoursOfOperation;
}

export interface MailroomArrayResponse {
  userMessage?: string | null;
  objectData: Mailroom[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface MailroomResponse {
  userMessage?: string | null;
  objectData: Mailroom;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface MailroomShippingLabelTemplate {
  template?: Template;
  defaultPrinterName?: string | null;
}

export interface MailroomShippingLabelTemplateResponse {
  userMessage?: string | null;
  objectData: MailroomShippingLabelTemplate;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface NotificationPlaceholder {
  placeholderName?: string | null;
  dropdownName?: string | null;
  description?: string | null;
  potentialValues?: string | null;
  /** @format date-time */
  created?: string | null;
}

export interface NotificationTemplate {
  /** @format int32 */
  id?: number;
  name?: string | null;
  subject?: string | null;
  /** @format int32 */
  notificationTypeId?: number;
  hasOverride?: boolean;
  body?: string | null;
  shortText?: string | null;
  /** @format date-time */
  createdOn?: string;
  updatedById?: string | null;
  updatedBy?: UserMin;
  /** @format date-time */
  updatedOn?: string;
  notificationType?: NotificationType;
  editableSections?: NotificationTemplateEditableSection[] | null;
}

export interface NotificationTemplateEditableSection {
  /** @minLength 1 */
  html: string;
  /** @minLength 1 */
  id: string;
}

export interface NotificationTemplateEditableSectionRequest {
  html?: string | null;
  /** @minLength 1 */
  id: string;
}

export interface NotificationTemplatePagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: NotificationTemplate[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface NotificationTemplatePagedListResponse {
  userMessage?: string | null;
  objectData: NotificationTemplatePagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface NotificationTemplateResponse {
  userMessage?: string | null;
  objectData: NotificationTemplate;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface NotificationType {
  name?: string | null;
  settingName?: string | null;
  /** @format date-time */
  created?: string | null;
  editable?: boolean;
  trigger?: string | null;
  sentTo?: string | null;
  configurationLocationinApp?: string | null;
  smsAvailable?: boolean;
  notificationPlaceholders?: NotificationPlaceholder[] | null;
  displayName?: string | null;
}

export interface PaymentError {
  error?: string | null;
  paymentMethod?: Card;
}

export interface PickupSession {
  /** @format uuid */
  id?: string;
}

export interface PickupSessionResponse {
  userMessage?: string | null;
  objectData: PickupSession;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Piece {
  /** @format int32 */
  id: number;
  pieceAssets: PieceAsset[];
  /** @format date-time */
  created: string;
  company: Company;
  user: UserMin;
  recipient?: UserMin;
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  lifecycleStage: PieceAction;
  users: PieceUser[];
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  pieceType: PieceType;
  /**
   *
   *
   * 1 = DateReceived
   *
   * 2 = HighDensityMail
   *
   * 3 = MailBox
   *
   * 4 = Location
   *
   * 5 = Carrier
   *
   * 6 = Lockers
   */
  workflow: Workflow;
  events: PieceEvent[];
  /** @format int32 */
  commentsCount: number;
  pieceDoc?: PieceDoc;
  recipientAutoDetection?: RecipientAutoDetection;
  trackingNumber?: string | null;
  pieceLocation?: PieceLocation;
  /** @format date-time */
  pickupDate?: string | null;
  /** @format date-time */
  actionRequiredBy?: string | null;
  mailTo?: Address;
  /** @format int32 */
  mailroomId: number;
  /** @format uuid */
  receiveSessionId: string;
  available: boolean;
  scanned: boolean;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  status: Status;
  sentStatus: boolean;
  trackingNumbers?: string[] | null;
  senderName?: string | null;
  purchaseOrderNumber?: string | null;
  purchaseInvoiceNumber?: string | null;
  reference1Number?: string | null;
  reference2Number?: string | null;
  reference3Number?: string | null;
  shippingCarriers?: ShippingCarrier[] | null;
  completedActions?: PieceEvent[] | null;
  recipientLocation?: UserLocation;
  recipientRoutes?: DeliveryRoute[] | null;
  /** @format date-time */
  archivedDate?: string | null;
  mailClassName?: string | null;
}

export interface PieceActiveCounters {
  /** @format int32 */
  unassignedCount: number;
  /** @format int32 */
  unstoredCount: number;
  /** @format int32 */
  unsentCount: number;
}

export interface PieceActiveCountersResponse {
  userMessage?: string | null;
  objectData: PieceActiveCounters;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAnnotation {
  /** @format int32 */
  id: number;
  /** @format int32 */
  pieceId: number;
  /**
   *
   *
   * 0 = Recipient
   *
   * 1 = Sender
   *
   * 2 = TrackingNumber
   *
   * 3 = Carrier
   *
   * 4 = Reference1Number
   *
   * 5 = Reference2Number
   *
   * 6 = Reference3Number
   *
   * 7 = PurchaseOrderNumber
   *
   * 8 = PurchaseInvoiceNumber
   *
   * 9 = MailClass
   */
  annotationType: AnnotationType;
  textValue?: string | null;
  boundingBox?: BoundingBox;
  pieceAnnotationsRecipient?: PieceAnnotationsRecipient;
  pieceAnnotationsTrackingNumber?: PieceAnnotationsTrackingNumber;
  pieceAnnotationsMailClass?: PieceAnnotationsMailClass;
  /** @format date-time */
  updated?: string;
}

export interface PieceAnnotationListResponse {
  userMessage?: string | null;
  objectData: PieceAnnotation[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAnnotationPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: PieceAnnotation[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface PieceAnnotationPagedListResponse {
  userMessage?: string | null;
  objectData: PieceAnnotationPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAnnotationResponse {
  userMessage?: string | null;
  objectData: PieceAnnotation;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAnnotations {
  /** @format int32 */
  pieceId: number;
  annotations: PieceAnnotation[];
}

export interface PieceAnnotationsMailClass {
  /** @format int32 */
  id: number;
  shippingMailClass: ShippingMailClass;
}

export interface PieceAnnotationsRecipient {
  /** @format int32 */
  id: number;
  recipientId?: string | null;
  recipientName?: string | null;
  recipientAddress?: string | null;
  recipientSearchString?: string | null;
  /**
   *
   *
   * 0 = Identified
   *
   * 1 = IdentifiedBasedOnPreviousAssignment
   *
   * 2 = IdentifiedVerificationRequired
   *
   * 3 = IdentifiedMultipleMatches
   *
   * 4 = IdentifiedAndNotExist
   *
   * 5 = Failed
   */
  status: RecipientAutoDetectionStatus;
  recipient?: User;
}

export interface PieceAnnotationsTrackingNumber {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 0 = Valid
   *
   * 1 = BadFormat
   *
   * 2 = Conflict
   */
  validationStatus: TrackingNumberValidationStatus;
  /**
   *
   *
   * 0 = None
   *
   * 1 = Sent
   *
   * 2 = Confirmed
   *
   * 3 = Failed
   *
   * 4 = Canceled
   */
  announcementStatus: TrackingNumberAnnouncementStatus;
  shippingCarrier: ShippingCarrier;
  /**
   *
   *
   * 0 = Code39
   *
   * 1 = Code128
   *
   * 2 = Codabar
   *
   * 3 = UCC128
   *
   * 4 = Code93
   *
   * 5 = UPCA
   *
   * 6 = EAN8
   *
   * 7 = UPCE
   *
   * 8 = EAN13
   *
   * 9 = I25
   *
   * 10 = DataMatrix
   *
   * 11 = PDF417
   *
   * 12 = QR
   *
   * 13 = DrvLic
   *
   * 14 = IMB
   *
   * 15 = BPO
   *
   * 16 = Aust
   *
   * 17 = Sing
   *
   * 18 = FourState
   *
   * 19 = Patch
   */
  barcodeType: BarcodeType;
}

export interface PieceArrayResponse {
  userMessage?: string | null;
  objectData: Piece[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAsset {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 1 = Original
   *
   * 2 = AutoCropped
   *
   * 3 = Cropped
   *
   * 5 = PickupSignature
   *
   * 6 = MlImage
   *
   * 7 = PdfDocument
   *
   * 8 = DeliveryImage
   *
   * 9 = PickupImage
   */
  pieceAssetType: PieceAssetType;
  /**
   *
   *
   * 1 = Large
   *
   * 2 = Medium
   *
   * 3 = Small
   */
  pieceAssetSize: PieceAssetSize;
  key?: string | null;
  url?: string | null;
  croppingBox?: BoundingBox;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface PieceAssetUpload {
  /**
   *
   *
   * 1 = Original
   *
   * 2 = AutoCropped
   *
   * 3 = Cropped
   *
   * 5 = PickupSignature
   *
   * 6 = MlImage
   *
   * 7 = PdfDocument
   *
   * 8 = DeliveryImage
   *
   * 9 = PickupImage
   */
  pieceAssetType: PieceAssetType;
  /**
   *
   *
   * 1 = Large
   *
   * 2 = Medium
   *
   * 3 = Small
   */
  pieceAssetSize: PieceAssetSize;
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  url: string;
}

export interface PieceAutoAction {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  pieceAutoActionUsers: string[];
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  action: PieceAction;
  payLoad?: string | null;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  pieceType: PieceType;
  /**
   *
   *
   * 0 = AllRecipients
   *
   * 1 = SpecificRecipients
   */
  automationSetType: AutomationSetType;
  /** @format date-time */
  createdDate: string;
}

export interface PieceAutoActionArrayResponse {
  userMessage?: string | null;
  objectData: PieceAutoAction[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceAutoActionRequest {
  /** @format int32 */
  id?: number;
  name?: string | null;
  pieceAutoActionUsers?: string[] | null;
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  action?: PieceAction;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  pieceType?: PieceType;
  /**
   *
   *
   * 0 = AllRecipients
   *
   * 1 = SpecificRecipients
   */
  automationSetType?: AutomationSetType;
}

export interface PieceAutoActionResponse {
  userMessage?: string | null;
  objectData: PieceAutoAction;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceComment {
  /** @format int32 */
  id: number;
  /** @format int32 */
  parentCommentId?: number | null;
  /** @format int32 */
  pieceId: number;
  /** @minLength 1 */
  text: string;
  user: User;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface PieceCommentArrayResponse {
  userMessage?: string | null;
  objectData: PieceComment[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceCommentListResponse {
  userMessage?: string | null;
  objectData: PieceComment[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceCommentResponse {
  userMessage?: string | null;
  objectData: PieceComment;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceCountersInbox {
  /** @format int32 */
  inboxNewCount: number;
  /** @format int32 */
  inboxInProcessCount: number;
  /** @format int32 */
  inboxCompletedCount: number;
}

export interface PieceCountersPending {
  /** @format int32 */
  openAndScanRequestedCount: number;
  /** @format int32 */
  pickUpRequestedCount: number;
  /** @format int32 */
  recycleRequestedCount: number;
  /** @format int32 */
  returnToSenderRequestedCount: number;
  /** @format int32 */
  mailToMeRequestedCount: number;
  /** @format int32 */
  shredRequestedCount: number;
  /** @format int32 */
  deliverRequestedCount: number;
}

export interface PieceCropped {
  /** @format int32 */
  pieceId: number;
  croppedAsset: PieceAsset;
  isSuccess: boolean;
}

export interface PieceDoc {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  status: Status;
  piecePages: PieceDocPage[];
  /** @minLength 1 */
  pdfKey: string;
  /** @minLength 1 */
  pdfUrl: string;
}

export interface PieceDocPage {
  /** @format int32 */
  id: number;
  /** @format int32 */
  pieceDocId: number;
  /** @minLength 1 */
  originalKey: string;
  /** @minLength 1 */
  croppedKey: string;
  /** @minLength 1 */
  thumbnailKey: string;
  /** @minLength 1 */
  originalUrl: string;
  /** @minLength 1 */
  croppedUrl: string;
  /** @minLength 1 */
  thumbnailUrl: string;
  /** @format int32 */
  sortOrder: number;
}

export interface PieceDocPageResponse {
  userMessage?: string | null;
  objectData: PieceDocPage;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceDocPageStorage {
  /** @minLength 1 */
  croppedUrl: string;
  /** @minLength 1 */
  originalUrl: string;
  /** @minLength 1 */
  thumbnailUrl: string;
  /** @minLength 1 */
  croppedKey: string;
  /** @minLength 1 */
  originalKey: string;
  /** @minLength 1 */
  thumbnailKey: string;
}

export interface PieceDocPageStorageResponse {
  userMessage?: string | null;
  objectData: PieceDocPageStorage;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceDocResponse {
  userMessage?: string | null;
  objectData: PieceDoc;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceDocStorage {
  /** @minLength 1 */
  pdfUrl: string;
  /** @minLength 1 */
  pdfKey: string;
}

export interface PieceDocStorageResponse {
  userMessage?: string | null;
  objectData: PieceDocStorage;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceDraftsCreated {
  pieces?: Piece[] | null;
}

export interface PieceDuplicateFound {
  /** @format int32 */
  pieceId?: number;
}

export interface PieceEvent {
  userId?: string | null;
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  actionTitle: string;
  /** @format date-time */
  created: string;
  /** @format int32 */
  lifecycleStage: number;
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  action: PieceAction;
  message: TermValue[];
  parent?: PieceEvent;
  /** @format int32 */
  parentId?: number | null;
  /**
   *
   *
   * 0 = ChainOfCustody
   *
   * 1 = System
   */
  actionType: PieceActionType;
}

export interface PieceLocation {
  container: Container;
  packageSpot?: string | null;
  /** @format int32 */
  orderNo: number;
  /** @minLength 1 */
  locationCodeFormatted: string;
}

export interface PieceLocationRequest {
  container?: ContainerRequest;
  packageSpot?: string | null;
  /** @format int64 */
  orderNo?: number | null;
}

export interface PieceMenuCounters {
  pendingCounters: PieceCountersPending;
  inboxCounters: PieceCountersInbox;
}

export interface PieceMenuCountersResponse {
  userMessage?: string | null;
  objectData: PieceMenuCounters;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceNextAction {
  pieceAction?: string | null;
  isForce?: boolean;
}

export interface PiecePagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: Piece[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface PiecePagedListResponse {
  userMessage?: string | null;
  objectData: PiecePagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceResponse {
  userMessage?: string | null;
  objectData: Piece;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceStorage {
  pieceAssets: PieceAssetUpload[];
}

export interface PieceStorageListResponse {
  userMessage?: string | null;
  objectData: PieceStorage[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceStorageResponse {
  userMessage?: string | null;
  objectData: PieceStorage;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PieceThumbnailsCreated {
  /** @format int32 */
  pieceId: number;
  pieceThumbnailAssets: PieceAsset[];
}

export interface PieceUser {
  /**
   *
   *
   * 0 = NA
   *
   * 10 = Created
   *
   * 20 = Assigned
   *
   * 30 = Submitted
   *
   * 40 = ActionRequested
   *
   * 50 = ActionTaken
   *
   * 60 = Archived
   *
   * -1 = Deleted
   */
  pieceState: PieceState;
  /** @minLength 1 */
  access: string;
  /** @minLength 1 */
  userId: string;
  nextActions: PieceNextAction[];
}

export interface PreparedImportUser {
  /** @format int32 */
  idx: number;
  userName?: string | null;
  autoAssignId?: string | null;
  /** @minLength 1 */
  email: string;
  phoneNumber?: string | null;
  supervisorEmail?: string | null;
  assistantsEmail?: string[] | null;
  roles: string[];
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  status: Status;
  location?: string | null;
  /**
   *
   *
   * 0 = Unchanged
   *
   * 1 = Added
   *
   * 2 = Activated
   *
   * 3 = Updated
   *
   * 4 = Inactivated
   *
   * 5 = Error
   */
  importState: ImportState;
  propertyModifications?: PropertyModification[] | null;
}

export interface PreparedImportUserListResponse {
  userMessage?: string | null;
  objectData: PreparedImportUser[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PrintLabel {
  success?: boolean;
  message?: string | null;
}

export interface PrintLabelResponse {
  userMessage?: string | null;
  objectData: PrintLabel;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PrinterInfo {
  success?: boolean;
  message?: string | null;
  name?: string | null;
  portName?: string | null;
  status?: string | null;
  isDefault?: boolean;
  isLocal?: boolean;
  isNetwork?: boolean;
  isWorkOffline?: boolean;
  isActive?: boolean;
  isPhysical?: boolean;
  driverName?: string | null;
}

export interface PrinterInfoResponse {
  userMessage?: string | null;
  objectData: PrinterInfo;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PrinterList {
  printers?: PrinterInfo[] | null;
}

export interface PrinterListResponse {
  userMessage?: string | null;
  objectData: PrinterList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Product {
  /** @format int32 */
  id: number;
  /**
   *
   *
   * 0 = Corporate
   *
   * 1 = University
   */
  businessDomain: BusinessDomain;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  description: string;
  /** @format double */
  monthlyPrice: number;
  /** @format double */
  yearlyPrice: number;
  features: ProductFeatures;
  /** @minLength 1 */
  payment_ProductId: string;
}

export interface ProductFeatures {
  /** @format int32 */
  storageMonths: number;
  /** @format int32 */
  mail: number;
  /** @format int32 */
  packages: number;
  /** @format int32 */
  recipients: number;
  /** @format int32 */
  mailrooms: number;
  support: boolean;
}

export interface ProductRequest {
  /** @format int32 */
  id?: number | null;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  description: string;
  /** @format double */
  monthlyPrice: number;
  /** @format double */
  yearlyPrice: number;
  /** @format int32 */
  storageMonths: number;
  /** @format int32 */
  mail: number;
  /** @format int32 */
  packages: number;
  /** @format int32 */
  recipients: number;
  /** @format int32 */
  mailrooms: number;
  support: boolean;
}

export interface ProductResponse {
  userMessage?: string | null;
  objectData: Product;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ProfileImageStorage {
  /** @minLength 1 */
  uploadUrl: string;
  /** @minLength 1 */
  profileImageUrl: string;
}

export interface ProfileImageStorageResponse {
  userMessage?: string | null;
  objectData: ProfileImageStorage;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface PropertyModification {
  name?: string | null;
  originalValue?: string | null;
  currentValue?: string | null;
}

export interface RdConnectApplicationInfo {
  appVersion?: string | null;
  platform?: string | null;
  machineKeyHash?: string | null;
}

export interface RdConnectInstance {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  companyId?: number;
  /** @format int32 */
  mailroomId?: number;
  serialNumber?: string | null;
  connectionId?: string | null;
  connectedUserId?: string | null;
  connectedUser?: User;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  updated?: string;
}

export interface RdConnectInstanceActivation {
  clientId?: string | null;
  clientSecret?: string | null;
  identityServerBaseUrl?: string | null;
}

export interface RdConnectInstanceActivationRequest {
  /** @minLength 1 */
  activationCode: string;
  /** @minLength 1 */
  machineKeyHash: string;
}

export interface RdConnectInstanceActivationResponse {
  userMessage?: string | null;
  objectData: RdConnectInstanceActivation;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface RdConnectInstanceListResponse {
  userMessage?: string | null;
  objectData: RdConnectInstance[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface RdConnectInstancePing {
  appState?: string | null;
  receiveSessionId?: string | null;
  /** @format int32 */
  capturedCounter?: number;
  applicationInfo?: RdConnectApplicationInfo;
}

export interface RdConnectInstancePingResponse {
  userMessage?: string | null;
  objectData: RdConnectInstancePing;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ReceiveSession {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format int32 */
  totalPiecesCount: number;
  /** @format int32 */
  readyPiecesCount: number;
  /** @format int32 */
  reviewPiecesCount: number;
  /** @format int32 */
  invalidPiecesCount: number;
  /** @format int32 */
  draftPiecesCount: number;
  user: User;
  /**
   *
   *
   * 1 = DateReceived
   *
   * 2 = HighDensityMail
   *
   * 3 = MailBox
   *
   * 4 = Location
   *
   * 5 = Carrier
   *
   * 6 = Lockers
   */
  workflow: Workflow;
  receiveSessionContainer: ReceiveSessionContainer;
  lastPieceAssets?: PieceAsset[] | null;
  isClosed: boolean;
}

export interface ReceiveSessionContainer {
  /** @format int32 */
  containerId?: number | null;
  /** @format date-time */
  createdDate?: string | null;
  /** @format int32 */
  containerTypeId?: number | null;
  containerNumber?: string | null;
  /**
   *
   *
   * 0 = None
   *
   * 1 = AddToBack
   *
   * 2 = AddToFront
   */
  sortOrder?: ContainerSortOrder;
}

export interface ReceiveSessionContainerRequest {
  /** @format int32 */
  containerId?: number | null;
  /** @format date-time */
  createdDate?: string | null;
  /** @format int32 */
  containerTypeId: number;
  containerNumber?: string | null;
  /**
   *
   *
   * 0 = None
   *
   * 1 = AddToBack
   *
   * 2 = AddToFront
   */
  sortOrder?: ContainerSortOrder;
}

export interface ReceiveSessionPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: ReceiveSession[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface ReceiveSessionPagedListResponse {
  userMessage?: string | null;
  objectData: ReceiveSessionPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ReceiveSessionRequest {
  /**
   *
   *
   * 1 = Single
   *
   * 2 = Automated
   *
   * 3 = Images
   */
  captureMethod: CaptureMethod;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  pieceType: PieceType;
  /**
   *
   *
   * 1 = DateReceived
   *
   * 2 = HighDensityMail
   *
   * 3 = MailBox
   *
   * 4 = Location
   *
   * 5 = Carrier
   *
   * 6 = Lockers
   */
  workflow: Workflow;
  receiveSessionContainer?: ReceiveSessionContainerRequest;
}

export interface ReceiveSessionResponse {
  userMessage?: string | null;
  objectData: ReceiveSession;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface RecipientAutoDetection {
  /** @format int32 */
  pieceId: number;
  recipientId?: string | null;
  recipientName?: string | null;
  recipientAddress?: string | null;
  recipientSearchString?: string | null;
  /**
   *
   *
   * 0 = Identified
   *
   * 1 = IdentifiedBasedOnPreviousAssignment
   *
   * 2 = IdentifiedVerificationRequired
   *
   * 3 = IdentifiedMultipleMatches
   *
   * 4 = IdentifiedAndNotExist
   *
   * 5 = Failed
   */
  status: RecipientAutoDetectionStatus;
  recipient?: UserMin;
}

export interface Setting {
  /**
   *
   *
   * 1 = String
   *
   * 2 = Boolean
   *
   * 3 = Number
   *
   * 4 = Array
   *
   * 5 = Json
   */
  type: SettingType;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  value: string;
  /**
   *
   *
   * 1 = General
   *
   * 2 = Notifications
   *
   * 3 = Mailroom
   *
   * 4 = UserRegistration
   *
   * 5 = AvailableActions
   *
   * 6 = AvailableNotifications
   *
   * 7 = ReceiveDefaults
   *
   * 8 = PieceAutomatedActions
   *
   * -2 = Private
   *
   * -1 = Internal
   */
  group: SettingGroup;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  companySettingValue: string;
  /** @minLength 1 */
  userSettingValue: string;
  /** @minLength 1 */
  mailroomSettingValue: string;
}

export interface SettingArrayResponse {
  userMessage?: string | null;
  objectData: Setting[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface SettingRequest {
  /**
   *
   *
   * 1 = String
   *
   * 2 = Boolean
   *
   * 3 = Number
   *
   * 4 = Array
   *
   * 5 = Json
   */
  type?: SettingType;
  name?: string | null;
  value?: string | null;
  /**
   *
   *
   * 1 = General
   *
   * 2 = Notifications
   *
   * 3 = Mailroom
   *
   * 4 = UserRegistration
   *
   * 5 = AvailableActions
   *
   * 6 = AvailableNotifications
   *
   * 7 = ReceiveDefaults
   *
   * 8 = PieceAutomatedActions
   *
   * -2 = Private
   *
   * -1 = Internal
   */
  group?: SettingGroup;
  description?: string | null;
  companySettingValue?: string | null;
  userSettingValue?: string | null;
  mailroomSettingValue?: string | null;
  userId?: string | null;
}

export interface SettingResponse {
  userMessage?: string | null;
  objectData: Setting;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ShippingCarrier {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
}

export interface ShippingCarrierArrayResponse {
  userMessage?: string | null;
  objectData: ShippingCarrier[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ShippingMailClass {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
}

export interface ShippingMailClassArrayResponse {
  userMessage?: string | null;
  objectData: ShippingMailClass[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface StringResponse {
  userMessage?: string | null;
  /** @minLength 1 */
  objectData: string;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Subscription {
  /** @format int32 */
  id: number;
  /** @format date-time */
  created: string;
  /** @format int32 */
  trialPeriodDays: number;
  /**
   *
   *
   * 0 = Trial
   *
   * 1 = TrialExpired
   *
   * 2 = Live
   *
   * 3 = Dunning
   *
   * 4 = Unpaid
   *
   * 5 = Future
   *
   * 6 = NonRenewing
   *
   * 7 = Canceled
   *
   * 8 = Expired
   */
  subscriptionStatus: SubscriptionStatus;
  /** @format int32 */
  remainingTrialDays: number;
  /**
   *
   *
   * 0 = Months
   *
   * 1 = Years
   */
  payment_Interval: PaymentInterval;
  product: Product;
  /** @format date-time */
  blockedAt?: string | null;
  /** @format date-time */
  cancelsAt?: string | null;
  subscriptionAddons: SubscriptionAddon[];
}

export interface SubscriptionAddon {
  /** @format int32 */
  id: number;
  /** @format int32 */
  subscriptionId: number;
  /** @format int32 */
  quantity: number;
  product: Product;
}

export interface SubscriptionAddonRequest {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  productId?: number;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  quantityAdded?: number;
}

export interface SubscriptionArrayResponse {
  userMessage?: string | null;
  objectData: Subscription[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface SubscriptionProduct {
  subscriptionProduct: Product;
  addonProducts: Product[];
}

export interface SubscriptionProductArrayResponse {
  userMessage?: string | null;
  objectData: SubscriptionProduct[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface SubscriptionProductResponse {
  userMessage?: string | null;
  objectData: SubscriptionProduct;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface SubscriptionRequest {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  productId?: number;
  defaultPaymentMethod?: string | null;
  /**
   *
   *
   * 0 = Months
   *
   * 1 = Years
   */
  payment_Interval?: PaymentInterval;
  subscriptionAddons?: SubscriptionAddonRequest[] | null;
}

export interface SubscriptionResponse {
  userMessage?: string | null;
  objectData: Subscription;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface SubscriptionSummary {
  /** @format int32 */
  storageMonths: number;
  /** @format int32 */
  maxMail: number;
  /** @format int32 */
  maxPackages: number;
  /** @format int32 */
  maxRecipients: number;
  /** @format int32 */
  maxMailrooms: number;
  /** @format int32 */
  usedMail: number;
  /** @format int32 */
  usedPackages: number;
  /** @format int32 */
  usedRecipients: number;
  /** @format int32 */
  usedMailrooms: number;
  support: boolean;
  subscription: Subscription;
  upcomingInvoice: UpcomingInvoice;
  lastPaymentError?: PaymentError;
  /** @format double */
  totalSum?: number;
}

export interface SubscriptionSummaryResponse {
  userMessage?: string | null;
  objectData: SubscriptionSummary;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Sync {
  products: Product[];
  subscriptions: Subscription[];
}

export interface SyncResponse {
  userMessage?: string | null;
  objectData: Sync;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface Template {
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format int32 */
  companyId?: number | null;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  status?: Status;
  key?: string | null;
  previewImageKey?: string | null;
  /**
   *
   *
   * 0 = ShippingLabel
   *
   * 1 = EmailNotification
   */
  type?: TemplateType;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
  url?: string | null;
  previewImageUrl?: string | null;
}

export interface TemplateListResponse {
  userMessage?: string | null;
  objectData: Template[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface TemplateResponse {
  userMessage?: string | null;
  objectData: Template;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface TermValue {
  /** @minLength 1 */
  text: string;
  url?: string | null;
}

export interface UpcomingInvoice {
  /** @format double */
  addonsAmount: number;
  /** @format double */
  productAmount: number;
  /** @format date-time */
  dueDate: string;
  /** @format double */
  startingBalance: number;
  /** @format double */
  endingBalance: number;
  /** @format double */
  appliedBalance: number;
  /** @format double */
  amountTotal: number;
  /** @format double */
  subtotal: number;
  /** @format double */
  proratedCredit: number;
  lines: UpcomingInvoiceLineItem[];
}

export interface UpcomingInvoiceLineItem {
  /** @minLength 1 */
  description: string;
  /** @format int64 */
  quantity: number;
  /** @format date-time */
  periodStart: string;
  /** @format date-time */
  periodEnd: string;
  proration?: boolean;
  /** @format double */
  unitPrice?: number | null;
  /** @format double */
  amount?: number | null;
}

export interface UpcomingInvoiceResponse {
  userMessage?: string | null;
  objectData: UpcomingInvoice;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface UpdateActiveSpanRequest {
  /** @format int32 */
  id?: number;
  /**
   *
   *
   * 0 = Sunday
   *
   * 1 = Monday
   *
   * 2 = Tuesday
   *
   * 3 = Wednesday
   *
   * 4 = Thursday
   *
   * 5 = Friday
   *
   * 6 = Saturday
   */
  dayOfWeek: DayOfWeek;
  /** @format int32 */
  open: number;
  /** @format int32 */
  close: number;
}

export interface UpdateBoundingBoxRequest {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  topLeftX?: number;
  /** @format int32 */
  topLeftY?: number;
  /** @format int32 */
  topRightX?: number;
  /** @format int32 */
  topRightY?: number;
  /** @format int32 */
  bottomLeftX?: number;
  /** @format int32 */
  bottomLeftY?: number;
  /** @format int32 */
  bottomRightX?: number;
  /** @format int32 */
  bottomRightY?: number;
}

export interface UpdateCompanyBrandingRequest {
  /** @format int32 */
  id: number;
  logoFileBase64?: string | null;
}

export interface UpdateCompanyRequest {
  /** @format int32 */
  id?: number;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  subdomain?: string | null;
  addresses?: AddressRequest[] | null;
}

export interface UpdateDeliveryRouteRequest {
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  name: string;
  locations?: LocationRequest[] | null;
}

export interface UpdateHoursOfOperationRequest {
  /** @format int32 */
  id?: number;
  timeZoneInfoId?: string | null;
  activeSpans?: UpdateActiveSpanRequest[] | null;
}

export interface UpdateLocationRequest {
  /** @format int32 */
  id: number;
  name?: string | null;
  /** @format int32 */
  sortOrder?: number;
  userOperations?: UserLocationOperation[] | null;
}

export interface UpdateMailroomRequest {
  /** @format int32 */
  id: number;
  name?: string | null;
  address?: AddressRequest;
  email?: string | null;
  /** @format date-time */
  openTime?: string | null;
  /** @format date-time */
  closeTime?: string | null;
  hoursOfOperation?: UpdateHoursOfOperationRequest;
}

export interface UpdateNotificationTemplateRequest {
  /** @minLength 1 */
  subject: string;
  shortText?: string | null;
  editableSections: NotificationTemplateEditableSectionRequest[];
}

export interface UpdatePieceCommentRequest {
  /** @format int32 */
  id?: number;
  text?: string | null;
}

export interface UpdatePieceDocRequest {
  /** @format int32 */
  id?: number;
  /** @maxLength 255 */
  pdfKey?: string | null;
}

export interface UpdatePiecePageRequest {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  pieceDocId: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  originalKey: string;
  /** @maxLength 255 */
  croppedKey?: string | null;
  /** @maxLength 255 */
  thumbnailKey?: string | null;
  /** @format int32 */
  sortOrder?: number;
}

export interface UpdatePieceRequest {
  /** @format int32 */
  id: number;
  recipientId?: string | null;
  pieceLocation?: PieceLocationRequest;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  pieceType?: PieceType;
  croppedFileBase64?: string | null;
  croppingBox?: UpdateBoundingBoxRequest;
}

export interface UpdatePiecesRequest {
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  action?: PieceAction;
  isForce?: boolean;
  shouldNotify?: boolean;
  /** @maxLength 255 */
  pickupSignatureKey?: string | null;
  /** @format date-time */
  pickupDate?: string | null;
  /** @format int32 */
  addressId?: number | null;
  qrCode?: string | null;
  /** @maxLength 100 */
  trackingNumber?: string | null;
  pieces?: UpdatePieceRequest[] | null;
  /** @maxLength 255 */
  deliveryImageKey?: string | null;
  /** @maxLength 255 */
  pickupImageKey?: string | null;
  pickUpIdCard?: string | null;
}

export interface UpdateUserRequest {
  id?: string | null;
  userName?: string | null;
  autoAssignId?: string | null;
  supervisorId?: string | null;
  addresses?: AddressRequest[] | null;
  roles?: string[] | null;
  profileImageUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  active?: boolean;
  assistants?: AssistantRequest[] | null;
  /** @format int32 */
  locationId?: number | null;
  phoneNumber?: string | null;
}

export interface UpdateUserRolesRequest {
  id?: string | null;
  roles?: string[] | null;
}

export interface UpdateUsersStatusRequest {
  userIds?: string[] | null;
  activate?: boolean;
}

export interface User {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  userName: string;
  /** @minLength 1 */
  autoAssignId: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  phoneNumber: string;
  /** @minLength 1 */
  supervisorId: string;
  roles: string[];
  company: Company;
  addresses: Address[];
  /** @format date-time */
  lockoutEnd: string;
  twoFactorEnabled: boolean;
  phoneNumberConfirmed: boolean;
  emailConfirmed: boolean;
  lockoutEnabled: boolean;
  /** @format int32 */
  accessFailedCount: number;
  /** @minLength 1 */
  profileImageUrl: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @minLength 1 */
  displayName: string;
  /** @format date-time */
  created: string;
  active: boolean;
  location: Location;
  assistants: UserMin[];
}

export interface UserArrayResponse {
  userMessage?: string | null;
  objectData: User[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface UserLocation {
  /** @minLength 1 */
  userId: string;
  user: UserMin;
  /** @minLength 1 */
  locationId: string;
  /** @minLength 1 */
  addedById: string;
  /** @format date-time */
  addedOn: string;
  /** @minLength 1 */
  addedByDisplayName: string;
}

export interface UserLocationOperation {
  /** @minLength 1 */
  userId: string;
  /**
   *
   *
   * 0 = Add
   *
   * 1 = Remove
   */
  operation: LocationUserOperationType;
}

export interface UserMin {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  userName: string;
  /** @minLength 1 */
  autoAssignId: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @minLength 1 */
  profileImageUrl: string;
  /** @minLength 1 */
  displayName: string;
  /** @format int32 */
  locationId: number;
  /** @minLength 1 */
  locationName: string;
}

export interface UserMinPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: UserMin[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface UserMinPagedListResponse {
  userMessage?: string | null;
  objectData: UserMinPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface UserPagedList {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  totalPages: number;
  items?: User[] | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface UserPagedListResponse {
  userMessage?: string | null;
  objectData: UserPagedList;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface UserResponse {
  userMessage?: string | null;
  objectData: User;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface ValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Record<string, string[]>;
  [key: string]: any;
}

export interface Variable {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  value: string;
}

export interface VariableArrayResponse {
  userMessage?: string | null;
  objectData: Variable[];
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface VariableRequest {
  /** @minLength 1 */
  key: string;
  value?: string | null;
}

export interface VariableResponse {
  userMessage?: string | null;
  objectData: Variable;
  errors?: Error[] | null;
  validationResult?: ValidationProblemDetails;
}

export interface CompanyListParams {
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface ContainerListParams {
  Workflows?: Workflow[];
  /**
   *
   *
   * 0 = All
   *
   * 1 = WithUnsentItems
   *
   * 2 = WithoutUnsentItems
   */
  StorageGroups?: ContainerFilterStorageGroups;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface ContainerContainerByRequestListParams {
  /** @format date-time */
  CreatedDate?: string;
  /** @format int32 */
  ContainerTypeId?: number;
  ContainerNumber?: string;
  SortOrder?: string;
  UserId?: string;
}

export interface DashboardGetInboundTrendsListParams {
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  periodType?: PeriodType;
}

export interface DashboardGetPercentageOfRecycleResponseListParams {
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  periodType?: PeriodType;
}

export interface DashboardGetAverageResponseTimeListParams {
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  periodType?: PeriodType;
}

export interface DashboardGetDailyRequestsListParams {
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  periodType?: PeriodType;
}

export interface DeliveryRoutesListParams {
  Name?: string;
  /** @format int32 */
  LocationId?: number;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface DeliveryRoutesDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface LocationListParams {
  Name?: string;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface LocationDeleteParams {
  /** @format int32 */
  id?: number;
}

export interface NotificationTemplateListParams {
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface PieceUnsentListParams {
  /** @format int32 */
  containerId?: number;
}

export interface PieceListParams {
  Include?: PieceIncludeOption[];
  /**
   *
   *
   * 0 = Mailroom
   *
   * 1 = Inbox
   */
  "Filter.Scope"?: PieceFilterScope;
  /** @format int32 */
  "Filter.ContainerId"?: number;
  /**
   *
   *
   * 0 = NA
   *
   * 10 = Created
   *
   * 20 = Assigned
   *
   * 30 = Submitted
   *
   * 40 = ActionRequested
   *
   * 50 = ActionTaken
   *
   * 60 = Archived
   *
   * -1 = Deleted
   */
  "Filter.PieceState"?: PieceState;
  /**
   *
   *
   * 0 = Sent
   *
   * 1 = Unsent
   */
  "Filter.PieceStatus"?: PieceStatus;
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  "Filter.LifecycleStage"?: PieceAction;
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  "Filter.Period"?: PeriodType;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  "Filter.Type"?: PieceType;
  /** @format date-time */
  "Filter.StartDate"?: string;
  /** @format date-time */
  "Filter.EndDate"?: string;
  "Filter.ReceivedBy"?: string;
  /** @format uuid */
  "Filter.ReceiveSessionId"?: string;
  /** @format int32 */
  "Filter.RecipientLocationId"?: number;
  "Filter.IsInMailCenterPiece"?: boolean;
  /**
   *
   *
   * 0 = All
   *
   * 1 = Assigned
   *
   * 2 = Unassigned
   */
  "Filter.AssignmentStatus"?: PieceAssignmentStatusFilter;
  /**
   *
   *
   * 0 = All
   *
   * 1 = Stored
   *
   * 2 = Unstored
   */
  "Filter.StoredStatus"?: PieceStoredStatusFilter;
  "Filter.Statuses"?: Status[];
  "Filter.ShippingCarrierIds"?: number[];
  "Filter.MailClassIds"?: number[];
  "Filter.SearchText"?: string;
  "Sorting.SortBy"?: string;
  "Sorting.Descending"?: boolean;
  /** @format int32 */
  "Paging.ItemsPerPage"?: number;
  /** @format int32 */
  "Paging.PageNumber"?: number;
}

export interface PieceSubmitDraftsCreateParams {
  /**
   * Receive session.
   * @format uuid
   */
  receiveSessionId?: string;
}

export interface PieceExportCsvListParams {
  Include?: PieceIncludeOption[];
  /**
   *
   *
   * 0 = Mailroom
   *
   * 1 = Inbox
   */
  "Filter.Scope"?: PieceFilterScope;
  /** @format int32 */
  "Filter.ContainerId"?: number;
  /**
   *
   *
   * 0 = NA
   *
   * 10 = Created
   *
   * 20 = Assigned
   *
   * 30 = Submitted
   *
   * 40 = ActionRequested
   *
   * 50 = ActionTaken
   *
   * 60 = Archived
   *
   * -1 = Deleted
   */
  "Filter.PieceState"?: PieceState;
  /**
   *
   *
   * 0 = Sent
   *
   * 1 = Unsent
   */
  "Filter.PieceStatus"?: PieceStatus;
  /**
   *
   *
   * 0 = NA
   *
   * 1 = EmailNotification
   *
   * 2 = SmsNotification
   *
   * 101 = Create
   *
   * 102 = Assign
   *
   * 103 = Store
   *
   * 104 = CropImage
   *
   * 201 = Submit
   *
   * 202 = RequestForward
   *
   * 203 = Move
   *
   * 301 = RequestRecycle
   *
   * 302 = RequestOpenAndScan
   *
   * 303 = RequestMail
   *
   * 304 = RequestPickUp
   *
   * 305 = RequestShred
   *
   * 306 = RequestDelivery
   *
   * 307 = RequestLockerPickUp
   *
   * 308 = RequestReturnToSender
   *
   * 401 = FinishRecycle
   *
   * 402 = FinishOpenAndScan
   *
   * 403 = FinishMail
   *
   * 404 = FinishPickUp
   *
   * 405 = FinishShred
   *
   * 406 = FinishPickUpWithSignature
   *
   * 407 = FinishPickUpWithQrCode
   *
   * 408 = FinishDelivery
   *
   * 409 = FinishDeliveryWithSignature
   *
   * 410 = FinishDeliveryWithQrCode
   *
   * 411 = FinishPickUpWithPinCode
   *
   * 412 = FinishPickUpUnload
   *
   * 413 = FinishDeliveryWithImage
   *
   * 414 = FinishPickupWithImage
   *
   * 415 = FinishReturnToSender
   *
   * 416 = FinishPickupWithIdCard
   *
   * 417 = FinishPickupMailbox
   *
   * 501 = RemindAction
   *
   * 502 = EscalateAction
   *
   * 503 = RemindReview
   *
   * 504 = EscalateReview
   *
   * 505 = RemindLockerPickup
   *
   * 506 = LockerExp
   *
   * 601 = ViewDoc
   *
   * 602 = DownloadDoc
   *
   * 603 = ScheduleDocumentNotViewedEscalation
   *
   * 604 = SchedulePieceNoActivityEscalation
   *
   * 605 = ScheduleDocumentNotViewed
   *
   * 606 = SchedulePieceNoActivity
   *
   * 607 = ScheduleLockersPickupReminder
   *
   * 608 = AutoCroppingComplete
   *
   * 609 = BarcodeDetectionComplete
   *
   * 610 = AutoCroppingSkipped
   *
   * 611 = AutoAssign
   *
   * 901 = Archive
   *
   * -1 = Delete
   */
  "Filter.LifecycleStage"?: PieceAction;
  /**
   *
   *
   * 0 = Week
   *
   * 1 = Month
   *
   * 2 = Year
   *
   * 3 = Today
   *
   * 4 = NotToday
   */
  "Filter.Period"?: PeriodType;
  /**
   *
   *
   * 1 = Mail
   *
   * 2 = Package
   */
  "Filter.Type"?: PieceType;
  /** @format date-time */
  "Filter.StartDate"?: string;
  /** @format date-time */
  "Filter.EndDate"?: string;
  "Filter.ReceivedBy"?: string;
  /** @format uuid */
  "Filter.ReceiveSessionId"?: string;
  /** @format int32 */
  "Filter.RecipientLocationId"?: number;
  "Filter.IsInMailCenterPiece"?: boolean;
  /**
   *
   *
   * 0 = All
   *
   * 1 = Assigned
   *
   * 2 = Unassigned
   */
  "Filter.AssignmentStatus"?: PieceAssignmentStatusFilter;
  /**
   *
   *
   * 0 = All
   *
   * 1 = Stored
   *
   * 2 = Unstored
   */
  "Filter.StoredStatus"?: PieceStoredStatusFilter;
  "Filter.Statuses"?: Status[];
  "Filter.ShippingCarrierIds"?: number[];
  "Filter.MailClassIds"?: number[];
  "Filter.SearchText"?: string;
  "Sorting.SortBy"?: string;
  "Sorting.Descending"?: boolean;
  /** @format int32 */
  "Paging.ItemsPerPage"?: number;
  /** @format int32 */
  "Paging.PageNumber"?: number;
}

export interface PieceAnnotationsListParams {
  /** @format int32 */
  PieceId?: number;
  /** @format uuid */
  ReceiveSessionId?: string;
  /**
   *
   *
   * 0 = Recipient
   *
   * 1 = Sender
   *
   * 2 = TrackingNumber
   *
   * 3 = Carrier
   *
   * 4 = Reference1Number
   *
   * 5 = Reference2Number
   *
   * 6 = Reference3Number
   *
   * 7 = PurchaseOrderNumber
   *
   * 8 = PurchaseInvoiceNumber
   *
   * 9 = MailClass
   */
  AnnotationType?: AnnotationType;
  /**
   *
   *
   * 0 = Valid
   *
   * 1 = BadFormat
   *
   * 2 = Conflict
   */
  TrackingNumberValidationStatus?: TrackingNumberValidationStatus;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface ReceiveSessionListParams {
  /** @format date-time */
  StartDate?: string;
  /** @format date-time */
  EndDate?: string;
  /**
   *
   *
   * 0 = All
   *
   * 1 = InProgress
   *
   * 2 = Closed
   */
  Status?: ReceiveSessionFilterStatus;
  Workflows?: Workflow[];
  CreatedBy?: string;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface ReceiveSessionOldListParams {
  /** @format date-time */
  StartDate?: string;
  /** @format date-time */
  EndDate?: string;
  /**
   *
   *
   * 0 = All
   *
   * 1 = InProgress
   *
   * 2 = Closed
   */
  Status?: ReceiveSessionFilterStatus;
  Workflows?: Workflow[];
  CreatedBy?: string;
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface SettingListParams {
  /** Setting group. */
  group?: string;
}

export interface ShippingLabelPrinterListListParams {
  /** @format int32 */
  rdConnectInstanceId?: number;
}

export interface ShippingLabelPrinterInfoListParams {
  /** @format int32 */
  rdConnectInstanceId?: number;
  name?: string;
}

export interface ShippingLabelPrintLabelTemplateCreateParams {
  /** @format int32 */
  rdConnectInstanceId?: number;
}

export interface TemplateCreateParams {
  Name: string;
  /**
   *
   *
   * 0 = ShippingLabel
   *
   * 1 = EmailNotification
   */
  Type: TemplateType;
}

export interface TemplateUpdateParams {
  /** @format int32 */
  Id?: number;
  Name?: string;
  /**
   *
   *
   * 0 = ShippingLabel
   *
   * 1 = EmailNotification
   */
  Type?: TemplateType;
}

export interface TemplateListParams {
  /**
   *
   *
   * 0 = ShippingLabel
   *
   * 1 = EmailNotification
   */
  templateType?: TemplateType;
}

export interface UserListParams {
  UserRole?: string;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  UserStatus?: Status;
  /** @format int32 */
  LocationId?: number;
  ExcludeLocationId?: boolean;
  /** @format int32 */
  PieceAutoActionId?: number;
  ExcludePieceAutoActionId?: boolean;
  Ids?: string[];
  AssistantsOfUserId?: string;
  NotAssistantsOfUserId?: string;
  ExcludeUserIds?: string[];
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface UserMinListParams {
  UserRole?: string;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  UserStatus?: Status;
  /** @format int32 */
  LocationId?: number;
  ExcludeLocationId?: boolean;
  /** @format int32 */
  PieceAutoActionId?: number;
  ExcludePieceAutoActionId?: boolean;
  Ids?: string[];
  AssistantsOfUserId?: string;
  NotAssistantsOfUserId?: string;
  ExcludeUserIds?: string[];
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface UserExportCsvCreateParams {
  UserRole?: string;
  /**
   *
   *
   * 0 = Deleted
   *
   * 1 = Active
   *
   * 2 = Draft
   */
  UserStatus?: Status;
  /** @format int32 */
  LocationId?: number;
  ExcludeLocationId?: boolean;
  /** @format int32 */
  PieceAutoActionId?: number;
  ExcludePieceAutoActionId?: boolean;
  Ids?: string[];
  AssistantsOfUserId?: string;
  NotAssistantsOfUserId?: string;
  ExcludeUserIds?: string[];
  SearchText?: string;
  SortBy?: string;
  Descending?: boolean;
  /** @format int32 */
  ItemsPerPage?: number;
  /** @format int32 */
  PageNumber?: number;
}

export interface NotificationHubOnTestMessageCreateParams {
  user?: string;
  message?: string;
}

export interface OnPieceRecipientDetectedCreateParams {
  recipientAutoDetectionResponse?: RecipientAutoDetection;
}

export interface OnPieceAnnotationsCreatedCreateParams {
  pieceAnnotationResponse?: PieceAnnotation[];
}

export interface OnPieceTrackingNumberDetectedCreateParams {
  pieceAnnotationsResponse?: PieceAnnotations;
}

export interface OnPieceCroppedCreateParams {
  pieceCroppedResponse?: PieceCropped;
}

export interface OnPieceThumbnailsCreatedCreateParams {
  pieceThumbnailsCreatedResponse?: PieceThumbnailsCreated;
}

export interface OnTrackingNumberStatusChangedCreateParams {
  pieceAnnotationResponse?: PieceAnnotation;
}

export interface OnPieceDuplicateFoundCreateParams {
  pieceDuplicateFoundResponse?: PieceDuplicateFound;
}

export interface OnPieceUpdatedCreateParams {
  pieceResponse?: Piece;
}

export interface OnDraftsCreatedCreateParams {
  piecesResponse?: PieceDraftsCreated;
}

export interface CameraInfoCreateParams {
  /** @format int32 */
  index?: number;
}

export interface OnCameraStartCreateParams {
  /** @format uuid */
  receiveSessionId?: string;
  /** @format int32 */
  index?: number;
}

export interface PrinterInfoCreateParams {
  connectionId?: string;
  name?: string;
}

export interface PrinterListCreateParams {
  connectionId?: string;
}

export interface PrintZplStartCreateParams {
  connectionId?: string;
  name?: string;
  zpl?: string;
}

export interface OnUserProfileUpdatedCreateParams {
  userResponse?: User;
}
